export default {
  common: {
    error: "Bir şeyler yanlış gitti",
    reload: "Yeniden yükle",
    errorNotification: "Bilgilendirildik ve en kısa sürede düzelteceğiz. Sorun devam ederse, lütfen",
    contactUs: "Bizimle İletişime Geçin.",
    language: "Dil",
    loading: "Yükleniyor...",
    loadingText: "Yükleniyor",
    save: "Kaydet",
    savedSuccessfully: "Başarıyla Kaydedildi",
    saving: "Kaydediliyor...",
    cancel: "İptal",
    edit: "Düzenle",
    delete: "Sil",
    add: "Ekle",
    search: "Ara",
    filter: "Filtrele",
    clear: "Temizle",
    preview: "Önizleme",
    default: "Varsayılan: {{value}}",
    optional: "İsteğe bağlı",
    required: "Gerekli",
    noData: "Veri yok",
  },
  // Places navigation
  places: {
    navigation: {
      locations: "Konumlar",
      cities: "Şehirler", 
      regions: "Bölgeler",
      countries: "Ülkeler",
      showOnMap: "Haritada göster",
      addLocation: "Konum ekle"
    },
    welcome: {
      title: "Locations So Super'a hoş geldiniz.",
      subtitle: "Başlamak için navigasyondan bir bölüm seçin."
    }
  },

  // Cities section
  cities: {
    title: "Şehirler",
    resourceSingular: "şehir",
    resourcePlural: "şehirler",
    headings: {
      name: "Ad",
      status: "Durum",
      locations: "Konumlar", 
      region: "Bölge",
      country: "Ülke"
    },
    breadcrumbs: {
      cities: "Şehirler"
    }
  },

  // Countries section  
  countries: {
    title: "Ülkeler",
    resourceSingular: "ülke", 
    resourcePlural: "ülkeler",
    headings: {
      name: "Ad",
      status: "Durum",
      locations: "Konumlar",
      cities: "Şehirler",
      regions: "Bölgeler"
    },
    breadcrumbs: {
      countries: "Ülkeler"
    }
  },

  // Regions section
  regions: {
    title: "Bölgeler",
    resourceSingular: "bölge",
    resourcePlural: "bölgeler", 
    headings: {
      name: "Ad",
      status: "Durum",
      locations: "Konumlar",
      cities: "Şehirler",
      country: "Ülke"
    },
    breadcrumbs: {
      regions: "Bölgeler"
    }
  },

  // Map section
  map: {
    title: "Harita",
    breadcrumbs: {
      locations: "Konumlar"
    }
  },

  // Import section
  import: {
    title: "CSV İçe Aktarma",
    breadcrumbs: {
      locations: "Konumlar"
    },
    new: {
      title: "Konumları CSV ile içe aktar",
      description: "Gerekli formatın örneğini görmek için örnek CSV şablonunu indirin",
      sampleTemplate: "örnek CSV şablonu",
      uploadAndContinue: "Yükle ve devam et",
      abortOnError: "Hata durumunda durdur",
      abortOnErrorHelp: "Bir hata varsa, içe aktarma duracak, hatayı gösterecek ve hiçbir konum içe aktarılmayacak.",
      needHelp: "Konum içe aktarmada yardıma mı ihtiyacınız var?"
    },
    show: {
      title: "CSV içe aktarma",
      youCanLeavePage: "Bu sayfadan ayrılabilirsiniz",
      backgroundMessage: "İçe aktarmanız arka planda çalışmaya devam edecek",
      importProgress: "İçe aktarma ilerlemesi",
      imported: "İçe aktarıldı",
      suffix: "konum",
      importLog: "İçe aktarma günlüğü",
      cancelImport: "İçe Aktarmayı İptal Et",
      cancelConfirmation: {
        title: "İçe Aktarmayı İptal Et",
        message: "Bu içe aktarma işini iptal etmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
        note: "Not: Devam eden işler için, iş tamamlanması gerekecek ve hemen ardından silinecek.",
        yesCancel: "Evet, içe aktarmayı iptal et",
        noContinue: "Hayır, içe aktarmaya devam et"
      },
      report: "Rapor",
      failedLocations: "Başarısız konumlar",
      uploadAnother: "Başka bir CSV yükle",
      backToLocations: "Konumlara geri dön",
      importSucceeded: "İçe aktarma başarılı",
      importFailed: "İçe aktarma başarısız"
    },
    messages: {
      uploadSuccess: "CSV başarıyla yüklendi",
      uploadError: "CSV yüklenemedi",
      pending: "İçe aktarma henüz başlamadı",
      inProgress: "İçe aktarma devam ediyor",
      completed: "İçe aktarma tamamlandı",
      invalidHeader: "Aşağıdaki sütunlar gerekli",
      invalidCsvFile: "Geçersiz CSV dosyası",
      aborted: "İçe aktarma iptal edildi",
      failed: "İçe aktarma başarısız",
      cancelled: "İçe aktarma iptal edildi"
    },
    errors: {
      csvTooLarge: "CSV çok büyük",
      languageNotEnabled: "'{{language}}' dili bu mağaza için etkinleştirilmemiş. Lütfen önce Ayarlar > Diller'de etkinleştirin.",
      fieldNotTranslatable: "'{{field}}' alanı çevrilebilir değil. Çevrilebilir alanlar: {{fields}}",
      locationError: "Slug ile konum: {{slug}} - {{error}}",
      planLimit: "Konumlar için plan sınırınıza ulaştınız"
    }
  },
  // Location form
  location: {
    index: {
      title: "Konumlar",
      addLocation: "Konum ekle",
      import: "İçe aktar",
      noPrioritySet: "Öncelik ayarlanmamış",
      published: "Yayınlandı",
      draft: "Taslak",
      resourceSingular: "konum",
      resourcePlural: "konumlar",
      headings: {
        name: "Ad",
        status: "Durum", 
        city: "Şehir",
        region: "Bölge",
        country: "Ülke",
        priority: "Öncelik"
      }
    },
    form: {
      title: "Konum ekle",
      editTitle: "Konumu düzenle",
      basicInformation: "Temel bilgiler",
      name: "Ad",
      namePlaceholder: "örn. Brians Bricks",
      nameHelpDefault: "Varsayılan: {{defaultName}}",
      details: "Detaylar",
      description: "Açıklama",
      descriptionPlaceholder: "Müşterilere bu konumun neyi özel kıldığını anlatın",
      address: "Adres",
      addressPlaceholder: "123 Ana Cadde, Şehir, Ülke",
      addressLine1: "Adres satırı 1",
      addressLine2: "Adres satırı 2",
      postalZipCode: "Posta / ZIP kodu",
      city: "Şehir",
      stateProvinceRegion: "Eyalet / İl / Bölge",
      country: "Ülke",
      phone: "Telefon",
      phonePlaceholder: "+1 (555) 123-4567",
      email: "E-posta", 
      emailPlaceholder: "store@example.com",
      website: "Web sitesi",
      websitePlaceholder: "https://www.example.com",
      image: "Resim",
      imagePlaceholder: "Resim URL'si girin",
      status: "Durum",
      statusActive: "Aktif",
      statusInactive: "Pasif",
      statusDraft: "Taslak",
      priority: "Öncelik",
      priorityHelpText: "Yüksek öncelikli konumlar arama sonuçlarında önce görünür",
      findOnMapButton: "Haritada bul"
    },
    validation: {
      addressNotFound: "Adres bulunamadı",
      createSuccess: "Konum başarıyla oluşturuldu", 
      updateSuccess: "Konum başarıyla güncellendi",
      checkFields: "Lütfen alanlarınızı kontrol edin",
      findOnMap: "Lütfen kaydetmeden önce konumunuzu haritada bulun"
    },
    errors: {
      loading: "Konum yüklenirken hata"
    },
    actions: {
      save: "Konumu kaydet",
      delete: "Konumu sil",
      preview: "Önizleme"
    },
    customFields: {
      title: "Özel alanlar",
      noCustomFields: "Yapılandırılmış özel alan yok",
      configureFields: "Alanları yapılandır",
      emptyState: "Henüz hiç özel alan yapılandırmadınız. Özel alanlar, işletmenizin ihtiyaçlarına özel ek bilgiler eklemenize olanak tanır."
    },
    openingHours: {
      title: "Çalışma saatleri",
      checkboxLabel: "Bu konumun açılış ve kapanış saatleri var",
      statusOpen: "Açık",
      statusOpen24h: "24 Saat Açık",
      statusClosed: "Kapalı",
      openingTimeLabel: "Açılış saati",
      closingTimeLabel: "Kapanış saati",
      days: {
        monday: "Pazartesi",
        tuesday: "Salı", 
        wednesday: "Çarşamba",
        thursday: "Perşembe",
        friday: "Cuma",
        saturday: "Cumartesi",
        sunday: "Pazar"
      }
    },
    table: {
      sortOptions: {
        recentlyAdded: "Son eklenenler",
        recentlyModified: "Son değiştirilenler"
      },
      filters: {
        status: "Durum",
        taggedWith: "Etiketli",
        locationStatus: "Konum durumu",
        noTagsToShow: "Gösterilecek etiket yok",
        searchPlaceholder: "Ara"
      },
      bulkActions: {
        setPublished: "Yayınlandı olarak ayarla",
        setUnpublished: "Yayınlanmadı olarak ayarla", 
        setPriority: "Öncelik ayarla",
        deleteLocations: "Konumları sil",
        exportCSV: "CSV olarak dışa aktar"
      },
      appliedFilters: {
        statusIs: "Durum {{status}}",
        taggedWith: "{{tag}} ile etiketli",
        nameIncludes: "Ad {{search}} içeriyor"
      },
      modals: {
        deleteTitle: "Konumları sil",
        deleteMessage: "{{count}} öğesini silmek istediğinizden emin misiniz?",
        deleteMessageAll: "Tüm konumları silmek istediğinizden emin misiniz?",
        prioritiseTitle: "{{count}} konuma öncelik ver",
        prioritiseTitleAll: "Tüm konumlara öncelik ver",
        delete: "Sil",
        cancel: "İptal"
      },
      emptyState: {
        noResultsHeading: "Hiç {{resourcePlural}} bulunamadı",
        noResultsText: "Filtreleri veya arama terimini değiştirmeyi deneyin",
        noDataHeading: "{{resourcePlural}} doldurmak için konum ekleyin",
        addLocation: "Konum Ekle",
        importFromCSV: "CSV'den içe aktar"
      },
      pagination: {
        label: "Sayfa {{page}} / {{pages}}"
      },
      messages: {
        updatedSuccessfully: "Başarıyla güncellendi",
        deletedSuccessfully: "Başarıyla silindi", 
        exportedSuccessfully: "Başarıyla dışa aktarıldı",
        error: "Bir şeyler yanlış gitti"
      }
    }
  },

  // SEO Editor
  seo: {
    title: "Sayfa içeriği",
    editTemplate: "SEO şablonunu düzenle", 
    pageTitle: "Başlık",
    pageDescription: "Açıklama",
    metaTitle: "Başlık",
    metaDescription: "Açıklama",
    urlHandle: "URL tutamacı",
    searchEnginePreview: "Arama motoru liste önizlemesi",
    editMeta: "Meta'yı düzenle",
    previewMeta: "Meta önizlemesi",
    loading: "Yükleniyor...",
    editingLocaleHelp: "{{locale}} içeriğini düzenleme."
  },

  // SEO Templates section
  seoTemplates: {
    title: "SEO şablonları",
    breadcrumbs: {
      seoTemplates: "SEO şablonları"
    },
    template: {
      title: "{{templateName}} şablonu - {{locale}}",
      discardChanges: "Değişiklikleri iptal et"
    },
    form: {
      pageContent: "Sayfa içeriği",
      searchEnginePreview: "Arama motoru liste önizlemesi",
      title: "Başlık",
      description: "Açıklama",
      pageTitle: "Sayfa başlığı",
      metaDescription: "Meta açıklaması",
      editingLocaleHelp: "{{locale}} çevirilerini düzenleme. Boş alanlar {{defaultLocale}} içeriğini gösterecek.",
      defaultValue: "Varsayılan: {{value}}"
    },
    language: {
      label: "Dil",
      defaultHelp: "Bu varsayılan diliniz",
      editingHelp: "{{locale}} çevirilerini düzenleme. Boş alanlar {{defaultLocale}} içeriğini gösterecek."
    },
    banner: {
      multipleLanguagesDisabled: "Çoklu dil etkinleştirilmemiş",
      enableInSettings: "Ayarlarda etkinleştir",
      multipleLanguagesInfo: "Çoklu dil için SEO şablonlarını yönetmek için, dil ayarlarınızda uluslararasılaştırmayı etkinleştirin. Şu anda yalnızca {{locale}} şablonları gösteriliyor."
    },
    badges: {
      errors: "Hatalar!",
      unsaved: "Kaydedilmemiş"
    },
    messages: {
      saveSuccess: "SEO şablonu başarıyla kaydedildi",
      saveError: "Şablon kaydedilemedi",
      error: "Hata..."
    }
  },
  // Area form
  area: {
    form: {
      basicInformation: "Temel bilgiler",
      name: "Ad",
      save: "Kaydet",
      saving: "Kaydediliyor...",
      cancel: "İptal",
      yourLocationsIn: "{{name}} içindeki konumlarınız",
      tableHeadings: {
        name: "Ad",
        status: "Durum",
        city: "Şehir",
        region: "Bölge",
        country: "Ülke"
      },
      resourceName: {
        singular: "{{name}} konumu",
        plural: "{{name}} içindeki konumlar"
      }
    }
  },

  // Settings section
  settings: {
    navigation: {
      map: "Harita",
      tags: "Etiketler",
      customFields: "Özel alanlar",
      languages: "Diller",
      plan: "Plan",
      addTag: "Etiket ekle",
      addField: "Alan ekle"
    },
    planBadges: {
      trial: "!",
      endsSoon: "Yakında bitiyor"
    },
    common: {
      loading: "Yükleniyor...",
      error: "Hata...",
      breadcrumbs: {
        settings: "Ayarlar"
      },
      skeleton: {
        customFields: "Özel alanlar",
        addField: "Alan ekle",
        name: "Ad",
        contentType: "İçerik türü",
        usedIn: "Kullanıldığı yer",
        field: "Alan",
        fields: "Alanlar"
      },
      messages: {
        savedSuccessfully: "{{setting}} ayarları başarıyla kaydedildi",
        couldntSave: "{{setting}} ayarları kaydedilemedi"
      }
    },
    map: {
      title: "Harita",
      messages: {
        savedSuccessfully: "Harita ayarları başarıyla kaydedildi",
        couldntSave: "Ayarlar kaydedilemedi"
      },
      mapboxToken: {
        title: "Mapbox token",
        description: "Mağaza bulucunuzu çalıştırmak için Mapbox token'ınızı girin",
        label: "Mapbox token",
        placeholder: "Haritanızı kullanmaya devam etmek için token'ı buraya girin.",
        placeholderManaged: "Ücretsiz harita yüklemeleriniz bittiğinde haritanızı kullanmaya devam etmek için token'ı buraya girin.",
        helpText: "Mapbox anahtarı oluşturma talimatlarımızı takip edin, ardından anahtarınızı yukarıya yapıştırın. Herhangi bir sorunla karşılaşırsanız, lütfen yardım için bizimle iletişime geçin.",
        linkInstructions: "Mapbox anahtarı oluşturma talimatları",
        linkSupport: "yardım için bizimle iletişime geçin"
      },
      managedToken: {
        title: "Harita yüklemeleri",
        description: "Yönetilen token ile {{max}} ücretsiz harita yüklemeniz var, bundan sonra kendi token'ınızı oluşturmanız gerekecek."
      },
      appearance: {
        title: "Görünüm",
        description: "Haritanızın görsel özelliklerini değiştirin"
      },
      mapStyle: {
        title: "Harita stili",
        options: {
          streets: "Sokaklar",
          outdoors: "Açık hava", 
          light: "Açık",
          dark: "Koyu",
          satellite: "Uydu",
          satelliteStreets: "Uydu Sokakları",
          navigationDay: "Gündüz Navigasyonu",
          navigationNight: "Gece Navigasyonu"
        }
      },
      searchBehaviour: {
        title: "Arama davranışı",
        description: "Ziyaretçilerin haritanızda konumları nasıl bulacağını kontrol eder.",
        geolocateLabel: "Ziyaretçinin konumunu otomatik olarak tahmin et ve yakındaki mağazaları göster",
        geolocateHelp: "Konum belirleme başarılı olursa, harita ziyaretçinin yakınına odaklanacak. Tahmini konum bulunamazsa, harita başlangıç pozisyonunda kalacak.",
        filterBehaviour: {
          title: "Filtre davranışı",
          all: {
            label: "Tüm etiketler",
            help: "Bir konumun filtrelerde görünmesi için seçilen tüm etiketlere sahip olması gerekir"
          },
          any: {
            label: "Herhangi bir etiket", 
            help: "Bir konumun filtrelerde görünmesi için seçilen etiketlerden herhangi birine sahip olabilir"
          }
        },
        keepSearchInView: {
          label: "Arama işaretçisini görünümde tut",
          help: "Arama sonuçları göründüğünde, harita tüm eşleşen konumları göstermek için uzaklaşacak"
        },
        distanceUnits: {
          title: "Mesafe birimleri",
          km: "Kilometre",
          miles: "Mil"
        },
        maxResults: {
          label: "Maksimum sonuç",
          help: "Arama sonuçlarında gösterilen konum sayısını sınırla",
          options: {
            results30: "30 sonuç"
          }
        },
        maxDistance: {
          label: "Maksimum mesafe", 
          help: "Yalnızca arama noktasından bu mesafe içindeki konumları göster",
          options: {
            unlimited: "Sınırsız"
          }
        },
        showLocationNames: {
          label: "Önerilerde konum adlarını göster",
          help: "Arama önerilerinde konum adlarını göster"
        },
        sortByPriority: {
          label: "Mesafe yerine önceliğe göre sırala",
          help: "Bu kutu işaretlenmişse maksimum mesafe (Sınırsız olmayan) ayarlamanız çok önerilir. Aksi takdirde müşterileriniz, makul mesafedeki konumların üstünde yüksek önceliğe sahip uzak konumları görecek."
        }
      },
      searchResults: {
        title: "Arama sonuçları",
        description: "Haritanızda konumların nasıl döndürüleceğini kontrol eder.",
        locationsLabel: "Arama sonuçları metni",
        locationsHelp: "Arama sonuçlarının üstünde gösterilen metin (örn., '5 konum gösteriliyor')",
        prefixLabel: "Arama sonuçları öneki", 
        prefixHelp: "Sonuç sayısından önce gösterilen metin"
      },
      popups: {
        title: "Açılır pencereler",
        showPopups: {
          label: "Açılır pencereleri göster",
          help: "Ziyaretçiler harita işaretçilerine tıkladığında konum detaylarını göster"
        }
      },
      whitelabel: {
        title: "Beyaz etiket",
        hideLabel: "Güçlendirilmiş metni gizle",
        hideHelp: "Mağaza bulucunuzdan markamızı kaldırın"
      }
    },
    languages: {
      title: "Diller",
      error: "Hata...",
      messages: {
        savedSuccessfully: "Dil ayarları başarıyla kaydedildi",
        couldntSave: "Dil ayarları kaydedilemedi"
      },
      banner: {
        upgradeTitle: "Çoklu dil desteği plan yükseltmesi gerektirir",
        upgradeAction: "Superest'e yükselt",
        upgradeMessage: "Varsayılan dilinizi hala değiştirebilirsiniz, ancak çoklu dilleri etkinleştirmek yükseltme gerektirir.",
        disabledMessage: "Çoklu dil ayarları mevcut planınızda devre dışı"
      },
      defaultLanguage: {
        title: "Varsayılan Dil", 
        description: "İçeriğinizin görüntüleneceği birincil dilinizi seçin.",
        label: "Varsayılan dil",
        help: "Belirli bir dil istenmediğinde bu dil kullanılacak"
      },
      internationalization: {
        title: "Uluslararasılaştırma",
        description: "Çoklu dilleri etkinleştirin. Daha fazla müşteriye ulaşın ve SEO'nuzu artırın.",
        enableLabel: "Çoklu dilleri etkinleştir",
        enableHelp: "Müşterilerin mağaza bulucunuzu farklı dillerde görüntülemesine izin verin"
      },
      supportedLanguages: {
        title: "Ek Desteklenen Diller",
        description: "Desteklemek istediğiniz dilleri seçin. Bir dili etkinleştirdikten sonra, tüm uygulamayı çevirmek için seçenekler göreceksiniz. Desteklenen diller için genel SEO şablonları ve tema değişken şablonları otomatik olarak oluşturulur.",
        defaultLocaleNote: "Bu varsayılan dilinizdir ve devre dışı bırakılamaz",
        shopifyEnabled: {
          label: "Bu dil Shopify mağazamda etkinleştirildi",
          importantNote: "Önemli:",
          description: "Bu dil Shopify mağazanızda etkinleştirilmemiş ve yayınlanmamışsa yukarıdaki kutuyu işaretlemeyin. Dilinizi önce Shopify mağazanızda etkinleştirmeniz gerekir, bunu yapmadıysanız Shopify konsolunuzda Ayarlar > Diller'e gidin"
        },
        urlFormats: {
          cleanUrls: "Temiz URL'ler:",
          betterSeo: "Daha iyi SEO ve kullanıcı deneyimi",
          queryUrls: "Sorgu parametresi URL'leri:",
          considerEnabling: "Daha iyi URL'ler için Shopify'da etkinleştirmeyi düşünün"
        },
        preview: {
          button: "Önizleme",
          tooltip: "{{language}} mağaza bulucu önizlemesi"
        },
        tooltips: {
          noTemplates: "Bu dil için varsayılan SEO şablonu yok. Özel çeviriler oluşturabilirsiniz"
        }
      }
    },
    tags: {
      title: "Etiketler",
      addTag: "Etiket ekle",
      error: "Hata",
      messages: {
        deletedSuccessfully: "Etiket başarıyla silindi",
        couldntDelete: "Etiket silinemedi",
        savedSuccessfully: "Etiket başarıyla kaydedildi",
        couldntSave: "Lütfen alanlarınızı kontrol edin",
        tagDeleted: "Etiket başarıyla silindi"
      },
      resourceName: {
        singular: "Etiket",
        plural: "Etiketler"
      },
      filters: {
        anyGroup: "Herhangi bir grup",
        inGroup: "Grupta",
        tagGroup: "Etiket grubu"
      },
      appliedFilters: {
        inGroup: "{{group}} grubunda",
        nameContains: "Etiket adı {{query}} aramasını içeriyor"
      },
      bulkActions: {
        deleteTag: "Etiketi sil",
        deleteTags: "Etiketleri sil"
      },
      form: {
        language: "Dil",
        title: "Başlık",
        description: "Açıklama",
        group: "Grup",
        groupPlaceholder: "Grup seçin",
        addGroup: "Ekle",
        editingTranslations: "{{language}} çevirilerini düzenleme. Boş alanlar {{defaultLanguage}} içeriğini gösterecek.",
        defaultValue: "Varsayılan: {{value}}",
        image: "Resim",
        imageUrl: "Resim URL'si"
      },
      actions: {
        save: "Kaydet",
        deleteTag: "Etiketi sil"
      },
      new: {
        title: "Etiket ekle",
        messages: {
          createSuccess: "Etiket başarıyla oluşturuldu",
          checkFields: "Lütfen alanlarınızı kontrol edin"
        },
        actions: {
          createTag: "Etiket oluştur"
        }
      }
    },
    customFields: {
      title: "Özel alanlar",
      addField: "Alan ekle",
      error: "Hata",
      resourceName: {
        singular: "Alan",
        plural: "Alanlar"
      },
      headings: {
        name: "Ad",
        contentType: "İçerik türü",
        usedIn: "Kullanıldığı yer"
      },
      emptyState: {
        heading: "Özel alanlarınızı oluşturun ve yönetin",
        createAction: "Alan oluştur",
        description: "İşletmenizin özel ihtiyaçları için özel alanlar kullanın. Bu alanlar sosyal medya bağlantıları veya mağaza yöneticisi adı ve e-postası gibi bilgiler olabilir"
      },
      pluralization: {
        location: "konum",
        locations: "konumlar"
      },
      form: {
        name: "Ad",
        contentType: "İçerik türü",
        key: "Anahtar",
        keyPrefix: "location.fields.",
        keyHelp: "Şablonlarınızda {{name}} konumunun içeriğine erişmek için bu anahtarı kullanın",
        translations: {
          title: "Çeviriler",
          showTranslations: "Çevirileri göster",
          hideTranslations: "Çevirileri gizle",
          description: "Çeviriler isteğe bağlıdır. Alan boşsa {{language}} dilindeki alan adı gösterilecek.",
          nameTranslation: "Ad ({{language}})",
          defaultValue: "Varsayılan: {{value}}"
        }
      },
      messages: {
        savedSuccessfully: "Alan başarıyla kaydedildi",
        couldntSave: "Alan kaydedilemedi",
        deletedSuccessfully: "Alan başarıyla silindi",
        couldntDelete: "Alan silinemedi"
      },
      actions: {
        delete: "Sil"
      },
      new: {
        title: "Alan ekle",
        messages: {
          savedSuccessfully: "Alan başarıyla kaydedildi",
          couldntSave: "Alan kaydedilemedi"
        }
      },
      contentTypes: {
        text: "Metin",
        textArea: "Metin alanı",
        email: "E-posta",
        number: "Sayı",
        phoneNumber: "Telefon numarası",
        time: "Zaman",
        url: "URL"
      }
    },
    plan: {
      title: "Plan",
      error: "Hata",
      changePlan: "Planı değiştir",
      usdPerMonth: "USD / ay",
      sections: {
        yourPlanIncludes: "Planınız şunları içerir",
        nextBillingDate: "Sonraki fatura tarihi",
        trial: "Deneme"
      },
      banners: {
        planUpdated: "Planınız güncellendi",
        thankYouUpgrading: "Yükseltme için teşekkürler!",
        letUsKnow: "Bize bildirin",
        improvementText: "İyileştirebileceğimiz bir şey varsa",
        trialCancellation: {
          title: "Deneme iptali bildirimi",
          message: "Ücretli bir plana yükselttiğinizde 14 günlük ücretsiz denemeniz iptal edilecektir."
        }
      },
      locations: {
        upTo: "Kadar",
        locations: "konum",
        unlimited: "Sınırsız konum",
        used: "Kullanılan",
        ofUsed: "{{max}}'den {{used}} kullanıldı"
      },
      trial: {
        daysLeft: "{{days}} gün kaldı",
        daysUsed: "{{total}} günden {{used}} kullanıldı",
        selectPlan: "Plan seçin",
        currentPlan: "Mevcut plan",
        trialBadge: "Deneme",
        currentBadge: "Mevcut",
        yourTrialJustStarted: "Denemeniz yeni başladı",
        trialEndsAfterToday: "Denemeniz bugünden sonra bitiyor",
        trialEndsTomorrow: "Denemeniz yarın bitiyor",
        daysLeftInTrial: "Denemenizde {{days}} gün kaldı",
        continueAddingLocations: "{{date}} sonrasında plan seçerek konum eklemeye devam edin",
        selectPlanToday: "Konum eklemeye devam etmek için lütfen bugün plan seçin"
      },
      footer: {
        description: "Locations So Super planınızı yönetin veya değiştirin. Kullanım şartlarımızı görün",
        termsOfService: "Kullanım Şartları",
        and: "ve",
        privacyPolicy: "Gizlilik Politikası"
      },
      features: {
        analytics: {
          title: "Analitik",
          description: "Kullanıcıların konumlarınızı nasıl kullandığını ve ne aradıklarını öğrenin"
        },
        internationalization: {
          title: "Çoklu dil desteği",
          description: "Çoklu dilleri etkinleştirerek SEO'nuzu artırın ve hedef pazarlarınızda iş yapın"
        },
        customThemes: {
          editLiquid: {
            title: "Liquid tema şablonlarını düzenleyin",
            description: "Liquid tema erişimi ile konumlarınızı istediğiniz şekilde görüntüleyin"
          },
          editStructuredData: {
            title: "İş yapılandırılmış verilerini düzenleyin",
            description: "Yapılandırılmış verileri düzenleyerek Google'ın tüm sayfalarınızı nasıl anladığını değiştirin"
          }
        }
      },
      edit: {
        title: "Planı değiştir",
        allPlansInclude: "Tüm planlar şunları içerir",
        needingMoreLocations: "Daha fazla konuma mı ihtiyacınız var?",
        footerQuestion: "Başlamadan önce sorularınız mı var?",
        sendMessage: "Bize mesaj gönderin",
        allFeatures: {
          seoDirectory: {
            title: "SEO dizini ve açılış sayfaları",
            description: "Tüm konumlarınız, şehirleriniz ve bölgeleriniz için SEO dizini oluşturun"
          },
          mapPage: {
            title: "Arama ve filtre ile harita sayfası",
            description: "Mapbox destekli haritada tüm konumlarınızı arayın ve filtreleyin"
          },
          tags: {
            title: "Etiketler",
            description: "Resim ve açıklamalarla etiketler oluşturun ve gruplandırın"
          },
          openingHours: {
            title: "Çalışma saatleri",
            description: "Konumlarınız için çalışma saatlerini ayarlayın ve görüntüleyin"
          },
          mapStyles: {
            title: "Harita stilleri",
            description: "Özel stillerle haritanızın görünümünü değiştirin"
          },
          customFields: {
            title: "Özel alanlar",
            description: "Sosyal medya bağlantılarından mağaza yöneticisi adına kadar istediğiniz alanları ekleyin"
          },
          csvUpload: {
            title: "CSV ile yükleme ve dışa aktarma",
            description: "Toplu kayıt ile konumları yükleyin ve düzenleyin"
          },
          richSnippets: {
            title: "Google için zengin snippet'ler",
            description: "Yerel iş yapılandırılmış verileri ile Google'ın tüm sayfalarınızı anlamasına yardımcı olun"
          },
          directionsAndCalls: {
            title: "Yön tarifleri ve aramalar",
            description: "Müşteriler konumlar için kolayca yön tarifi alabilir ve arama yapabilir"
          },
          languageSupport: {
            title: "Dil desteği",
            description: "Varsayılan dili İngilizce olmayan başka bir dile değiştirin. Verilen şablonlar 32 ana dil için hazır çevirilerle birlikte gelir"
          }
        }
      },
      planCard: {
        bestToCustomize: "Özelleştirmek için en iyi",
        currentPlan: "Mevcut plan",
        chooseThisPlan: "Bu planı seçin",
        locationsSection: "Konumlar",
        featuresSection: "Özellikler",
        upTo: "Kadar",
        locations: "konum",
        tooltipTooManyLocations: "Bu plan için çok fazla konumunuz veya etkinleştirilmiş diliniz var"
      },
      confirmation: {
        error: "Plan onayı hatası"
      }
    }
  },

  // Themes section
  themes: {
    title: "Temalar",
    currentTheme: {
      title: "Mevcut tema",
      description: "Bu, kullanıcıların konum uygulamanıza eriştiğinde gördüğü temadır"
    },
    themeLibrary: {
      title: "Tema şablonları",
      description: "Konumlarınızın tema şablonlarını yönetin. Şablonları ekleyin ve yayınlayarak çevrimiçi konumlarınızın görünümünü değiştirin"
    },
    skeleton: {
      currentThemeDescription: "Bu, kullanıcıların konum uygulamanıza eriştiğinde gördüğü temadır"
    },
    modal: {
      overrideTitle: "Mevcut temaya erişmek istiyor musunuz?",
      override: "Erişim",
      cancel: "İptal",
      undoWarning: "Bu işlem geri alınamaz"
    },
    messages: {
      publishSuccess: "Şablon başarıyla yayınlandı",
      publishError: "Şablon yayınlanamadı",
      error: "Bir şeyler yanlış gitti"
    },
    emptyStates: {
      settings: {
        heading: "Bu temanın ayarları yok",
        description: "Şablon düzenleyicide ayarlar oluşturun",
        createSettings: "Ayarlar oluştur",
        upgradePlan: "Planı yükselt",
        upgradeRequired: "Ayarlar oluşturmak için plan yükseltmesi gerekli"
      },
      language: {
        heading: "Bu temanın dil şablonları yok",
        description: "Şablon düzenleyicide dil şablonları oluşturun",
        createLanguageTerms: "Dil şablonları oluştur",
        upgradePlan: "Planı yükselt",
        upgradeRequired: "Dil şablonları oluşturmak için plan yükseltmesi gerekli"
      }
    },
    templates: {
      categories: {
        templates: "Şablonlar",
        schemas: "Şemalar",
        styles: "Stiller",
        liquidReference: "Liquid referansı"
      },
      items: {
        landing: "Açılış sayfası",
        directory: "Dizin",
        country: "Ülke",
        region: "Bölge",
        city: "Şehir",
        location: "Konum",
        language: "Dil",
        settings: "Ayarlar",
        stylesheet: "Stil sayfası"
      },
      errors: {
        errorsInTemplate: "Şablonda hatalar",
        error: "Hata"
      },
      badges: {
        errors: "Hatalar!",
        unsaved: "Kaydedilmemiş"
      },
      actions: {
        viewTheme: "Temayı görüntüle",
        discard: "İptal",
        save: "Kaydet"
      }
    },
    language: {
      messages: {
        saveSuccess: "Tema şablonu çevirisi başarıyla kaydedildi",
        saveError: "Şablon kaydedilemedi"
      },
      form: {
        language: "Dil",
        defaultLanguageHelp: "Bu varsayılan diliniz",
        translationHelp: "{{selectedLocale}} çevirilerini düzenleme. Boş alanlar {{defaultLocale}} (varsayılan diliniz) içeriğini gösterecek"
      },
      banner: {
        multipleLanguagesNotEnabled: {
          title: "Çoklu dil etkinleştirilmemiş",
          action: "Ayarlarda etkinleştir",
          description: "Çevirileri yönetmek için dil ayarlarınızda uluslararasılaştırmayı etkinleştirin. Şu anda yalnızca {{locale}} çeviri şablonları gösteriliyor"
        },
        translating: {
          title: "{{from}}'den {{to}}'ye çeviriyor",
          description: "Boş alanlar otomatik olarak {{defaultLocale}} kullanıcı içeriğini gösterecek, ancak {{selectedLocale}}'de farklı içerik istediğiniz alanları çevirmeniz gerekir"
        }
      },
      accessLanguageTerms: "{{code}} ile {{category}} dil şablonlarına erişin",
      fields: {
        // Common language fields - add specific ones as needed
        title: "Başlık",
        description: "Açıklama",
        heading: "Başlık",
        subheading: "Alt başlık",
        button_text: "Düğme metni",
        link_text: "Bağlantı metni",
        placeholder: "Yer tutucu",
        label: "Etiket",
        help_text: "Yardım metni",
        error_message: "Hata mesajı",
        success_message: "Başarı mesajı",

        // Opening hours
        Monday: "Pazartesi",
        Tuesday: "Salı",
        Wednesday: "Çarşamba",
        Thursday: "Perşembe",
        Friday: "Cuma",
        Saturday: "Cumartesi",
        Sunday: "Pazar",
        opening_hours_format: "Çalışma saatleri formatı",
        closes_at_format: "Kapanış saati formatı",
        opens_at_format: "Açılış saati formatı",
        opens_on: "Açılış günü",
        open_24h: "24 saat açık",
        open: "Açık",
        closed: "Kapalı",
        closes_at: "Kapanış saati",
        opens_at: "Açılış saati",

        // Map
        search_map: "Harita ara",
        search_area: "Bu alanı ara",
        view_map: "Harita",
        view_list: "Liste",
        open_filters: "Filtreler",
        stores_near_you: "Yakınınızdaki mağazalar",
        header: "Mağaza bul!",
        search_placeholder: "Posta kodu veya adres yazın...",
        no_listings: "Dünyayı aradık ama arama teriminiz için hiçbir konum bulamadık. Filtreleri veya arama konumunu değiştirmeyi deneyin",

        // Directory
        view_directory: "Mağaza dizini",

        // Location
        get_directions: "Yön tarifi al",
        call: "Ara",
        view_website: "Web sitesi",
        email: "E-posta",
        opening_hours_header: "Çalışma saatleri",
        description_header: "Bilgi",
        phone_number_header: "Telefon numarası",
        address_header: "Adres",
        tag_groups_to_display: "Gösterilecek etiket grupları"
      },
      categories: {
        // Common language categories - add specific ones as needed
        general: "Genel",
        navigation: "Navigasyon",
        forms: "Formlar",
        buttons: "Düğmeler",
        messages: "Mesajlar",
        errors: "Hatalar",
        opening_hours: "Çalışma saatleri",
        map: "Harita",
        directory: "Dizin",
        location: "Konum"
      }
    },
    settings: {
      messages: {
        saveSuccess: "Tema başarıyla kaydedildi",
        saveError: "Tema kaydedilemedi"
      },
      accessSettings: "{{code}} ile {{category}} ayarlarına erişin",
      fields: {
        // Colors
        color_text: "Metin rengi",
        color_text_heading: "Başlık metin rengi",
        color_background: "Arka plan rengi",
        color_accent: "Vurgu rengi",
        color_text_positive: "Pozitif metin rengi",
        color_text_negative: "Negatif metin rengi",
        dark_theme: "Koyu tema",
        color_marker: "İşaretçi rengi",
        color_search_marker: "Arama işaretçi rengi",

        // Typography
        base_font_size: "Temel yazı tipi boyutu",

        // Buttons
        border_radius: "Kenarlık yarıçapı",

        // Images
        aspect_ratio: "En boy oranı",
        fit: "Sığdırma",

        // Spacing
        page_width: "Sayfa genişliği",
        page_width_small: "Küçük sayfa genişliği",
        gutter_desktop: "Masaüstü dış boşluk",
        gutter_mobile: "Mobil dış boşluk",
        desktop_vertical_spacing: "Masaüstü dikey boşluk",
        mobile_vertical_spacing: "Mobil dikey boşluk",

        // Breakpoints
        breakpoint_xs: "XS kesme noktası",
        breakpoint_sm: "SM kesme noktası",
        breakpoint_md: "MD kesme noktası",

        // Map
        search_on_move: "Hareket sırasında ara",
        scroll_to_zoom: "Yakınlaştırmak için kaydır",

        // Landing page
        sidebar_width: "Kenar çubuğu genişliği",
        sidebar_min_height: "Kenar çubuğu minimum yüksekliği",
        marker_image_src: "İşaretçi resim kaynağı",
        show_filter_descriptions: "Filtre açıklamalarını göster",

        // Location page
        tag_groups_to_display: "Gösterilecek etiket grupları",
        tag_groups_to_display_as_icons: "İkon olarak gösterilecek etiket grupları",
        show_related_locations: "İlgili konumları göster",

        // Locations
        hide_regions: "Bölgeleri gizle"
      },
      categories: {
        colors: "Renkler",
        typography: "Tipografi",
        buttons: "Düğmeler",
        images: "Resimler",
        spacing: "Boşluk",
        breakpoints: "Kesme noktaları",
        map: "Harita",
        landing_page: "Açılış sayfası",
        location_page: "Konum sayfası",
        locations: "Konumlar"
      }
    },
    navigation: {
      sublimeTheme: "Sublime teması",
      settings: "Ayarlar",
      language: "Dil",
      templates: "Şablonlar",
      changeTheme: "Temayı değiştir",
      viewDirectory: "Dizini görüntüle",
      viewLandingPage: "Açılış sayfasını görüntüle"
    },
    card: {
      lastUpdated: "Son güncelleme",
      view: "Görüntüle",
      customize: "Özelleştir",
      publish: "Yayınla",
      actions: "Eylemler"
    }
  },

  // Analytics section
  analytics: {
    title: "Analitik",
    timePeriods: {
      last7days: "Son 7 gün",
      last30days: "Son 30 gün"
    },
    comparison: {
      compareToPrevious: "Önceki dönemle karşılaştır",
      stopComparing: "Önceki dönemle karşılaştırmayı durdur"
    },
    sections: {
      searchLocations: "Konum ara"
    },
    cards: {
      sessions: "Oturumlar",
      topSearches: "En popüler aramalar",
      topLandingPageType: "En popüler açılış sayfası türü",
      topPageViewsBySession: "Oturum başına en çok görüntülenen sayfalar",
      topLocations: "En popüler konumlar",
      topReferrers: "En popüler yönlendiriciler",
      searches: "Aramalar",
      topLandingPagesBySession: "Oturum başına en çok görüntülenen açılış sayfaları"
    },
    chartLabels: {
      desktop: "Masaüstü"
    }
  },

}; 